export default {
  computed: {
    isFormModified() {
      return Object.keys(this.veeValidateFields).some(
        item => this.veeValidateFields[item].dirty
      )
    },
  },
  methods: {
    confirmExit() {
      return this.$swal({
        text: `Are you sure you? Your changes will not be saved!`,
        icon: "error",
        buttons: {
          cancel: "Keep Editing",
          confirm: {
            text: "Yes, Discard",
            value: true,
            className: "bg-red focus:bg-red hover:bg-red active:bg-red",
          },
        },
      })
    },
    confirmDelete(msg) {
      return this.$swal({
        text: msg || `Are you sure you want to delete?`,
        icon: "error",
        buttons: {
          cancel: "Cancel",
          confirm: {
            text: "Delete",
            value: true,
            className: "bg-red focus:bg-red hover:bg-red active:bg-red",
          },
        },
      })
    },
  },
}
